<template>
  <div>
    <h4>Basic Settings</h4>
    <div>
      <div class="label">Board Title</div>
      <input @input="isDirty = true" type="text" class="form-control" v-model="settings.title" />
    </div>
    <div>
      <div class="label mt-2 mb-1">Enable Shifts</div>
      <checkbox-with-label
        :label="'Enable Shifts'"
        v-model="settings.enableShifts"
        @input="(value) => (isDirty = true)"
      ></checkbox-with-label>
    </div>

    <div>
      <div class="label mt-2 mb-1">Send "InProgress" Tasks back to "Tasks" on shift handover</div>
      <checkbox-with-label
        :label="'Enable automatic move of In Progress tasks back to Tasks on shift handover'"
        v-model="settings.enableAutomaticStatusChangeOnShiftHandover"
        @input="(value) => (isDirty = true)"
      ></checkbox-with-label>
    </div>

    <hr />
    <div class="d-flex justify-content-end pt-3">
      <button :disabled="!isDirty" class="btn btn-save btn-sm btn-success" @click="save()">
        <i class="far fa-save"></i>
        Save changes
      </button>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { SettingsStore, SettingsModule } from '@/store/settings';
  import CheckboxWithLabel from '../Misc/CheckboxWithLabel.vue';

  @Component({
    components: {
      'checkbox-with-label': CheckboxWithLabel,
    },
  })
  export default class BoardInitialSettings extends Vue {
    private isDirty = false;
    private settingsStore: SettingsModule = SettingsStore;

    get settings() {
      return this.settingsStore.initialBoardSettings;
    }

    async save() {
      await this.settingsStore.updateBoardInitialSettings();
      this.isDirty = false;
    }
  }
</script>
